import React from 'react';
import { Link } from 'react-router-dom';
import LogoIcon from './LogoIcon';
import LogoText from './LogoText';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', className = '' }) => {
  return (
    <Link to="/" className={`group flex items-center ${className}`} aria-label="ScaleNix home">
      <LogoIcon size={size} />
      <LogoText size={size} />
    </Link>
  );
};

export default Logo;
